import { useUser } from '../hooks/use-user';
import { SettingsIcon } from '../icons/settings';
import { UserIcon } from '../icons/user';
import { ResLoading } from './res-loading';
import { Timer } from './timer';
import { useLocation } from 'wouter';

export const UserPreview = () => {
  const [, setLocation] = useLocation();
  const { data: user, error, isLoading } = useUser();

  if (!user || isLoading) return <ResLoading />;
  if (error) return <div>{error.message}</div>;

  return (
    <div className="flex items-center gap-4">
      <div className="flex flex-col text-right">
        <h1 className="font-bold text-xl">{user.name}</h1>
        <p className="text-neutral-500 text-sm font-bold flex items-center justify-end gap-2">
          <span className="capitalize font-normal">{user.role}</span>
          <span>•</span>
          <span className="text-green-500">
            <Timer start={user.started_at} />
          </span>
        </p>
      </div>
      <UserIcon className="w-12 h-12 rounded-full fill-green-500" />
      {user.is_admin && (
        <SettingsIcon
          className="w-8 h-8 rounded-full fill-neutral-500 hover:scale-110 transition-all cursor-pointer"
          onClick={() => setLocation('/settings')}
        />
      )}
    </div>
  );
};
